import { useLayoutAppKind } from "@ui/layouts/layoutProvider";
import { ClipCount } from "@ui/molecules/ClipCount/ClipCount";
import { PrivatePublicIcon } from "@ui/molecules/PrivatePublicIcon/PrivatePublicIcon";
import { UpdatedAt } from "@ui/UpdatedAt";
import { Show } from "solid-js";
import type { ListBoardItemResponse } from "@/client";
import { BoardCard } from "~/modules/shared/boards/BoardCard/BoardCard";
import { boardDetailsBasePath, buildBoardDetailsUrl } from "../boardDetailsUrl";

export const BoardsItem = (props: {
	board: ListBoardItemResponse;
	projectId?: string;
	variant?: "mine" | "following";
}) => {
	const appKind = useLayoutAppKind();
	const variant = () => props.variant ?? "mine";
	const showPrivacyIcon =
		variant() === "mine" && (appKind === "askgvt" || appKind === "studio");
	const detailsRoute = boardDetailsBasePath(appKind, props.projectId);
	const viewLink = buildBoardDetailsUrl(detailsRoute, props.board);
	const owner = () => props.board.owner;

	return (
		<BoardCard
			href={viewLink}
			class={variant() === "following" ? "board-item--following" : undefined}
			title={props.board.title}
			thumbnails={props.board.thumbnail_images ?? []}
			info={
				<>
					<Show when={showPrivacyIcon}>
						<PrivatePublicIcon privacy={props.board.privacy} />
					</Show>
					<Show when={variant() === "following" && owner()}>
						<div class="board-item-owner">
							<Show
								when={owner()?.profile_picture_url}
								fallback={
									<div class="board-item-owner-avatar board-item-owner-avatar--placeholder" />
								}
							>
								<img
									src={owner()?.profile_picture_url}
									alt=""
									class="board-item-owner-avatar"
								/>
							</Show>
							<div class="board-item-owner-details">
								<span class="board-item-owner-name">
									{owner()?.display_name}
								</span>
								<span class="board-item-owner-handle">@{owner()?.handle}</span>
							</div>
						</div>
					</Show>
				</>
			}
			meta={
				<>
					<UpdatedAt updatedAt={props.board.updated_at} />
					<ClipCount clipCount={props.board.clip_count ?? 0} />
				</>
			}
		/>
	);
};
